module.exports = __webpack_public_path__ + "static/media/settings-outline.6a0f8dc2.svg";